import * as z from "zod";

export const addVirtualPosIPGFormSchema = z.object({
  fullName: z.string().optional(),
  mobile: z.string().min(11, "شماره موبایل باید 11 رقم باشد."),
  amount: z.string().nonempty("مبلغ را وارد کنید."),
  description: z.string().optional(),
});

export type addVirtualPosIPGValues = z.infer<typeof addVirtualPosIPGFormSchema>;
